import script from "./DrawRule.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawRule.vue?vue&type=script&setup=true&lang=js"

import "./DrawRule.vue?vue&type=style&index=0&id=f154ebd8&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f154ebd8"]])

export default __exports__